import { useWorkflow } from '@/react/portainer/gitops/workflows/queries/useWorkflow';
import { getWorkflowLink } from '@/react/portainer/gitops/workflows/utils';

import { Link } from '@@/Link';

import { LineItem } from './LineItem';

export function WorkflowLineItem({ workflowId }: { workflowId: number }) {
  const { to, params } = getWorkflowLink({ id: workflowId });
  const workflowQuery = useWorkflow(workflowId);
  const workflowName = workflowQuery.data?.name;

  return (
    <LineItem
      label="Workflow"
      value={
        workflowName ? (
          <Link to={to} params={params} data-cy="git-workflow-link">
            {workflowName}
          </Link>
        ) : workflowQuery.isLoading ? (
          ''
        ) : (
          'not found'
        )
      }
      title={workflowName ?? ''}
      isLoading={workflowQuery.isLoading}
      isError={
        workflowQuery.isError || (!workflowQuery.isLoading && !workflowName)
      }
      isValid={!!workflowName}
      data-cy="git-workflow"
    />
  );
}
